import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/skillsewa/r/skillsewa.com-trans/src/components/elements/bars/DesktopNavbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollArea"] */ "/home/skillsewa/r/skillsewa.com-trans/src/components/ui/scroll-area.tsx");
